import React, { Suspense, lazy } from 'react';
const ReactApexChart = lazy(() => import('react-apexcharts'));

const LineChart = ({ chart_title, chart_data,chart_categories  }) => {
  const series = [
    {
      name: '',
      data: chart_data,
    },
  ];

  const chartOptions = {
    chart: {
      height: 400,
      type: 'line',
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
    },
    title: {
      text: [chart_title],
      align: 'left',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // alternating row colors
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: chart_categories,
    },
  };

  return (
    <div id="chart">
      <Suspense fallback={<div style={{ textAlign: 'center' }}>Loading chart...</div>}>
        <ReactApexChart options={chartOptions} series={series} type="line" height={400} />
      </Suspense>
    </div>
  );
};

export default LineChart;
